import { OutputData } from '@editorjs/editorjs'

import { IBase } from './base'
import { IBenefit } from './benefit'
import { IProgramModule } from './program-module'

export enum BENEFIT_ICONS_ENUM {
	HEALTH_EDUCATION = 'icon-health-education',
	CLIENT_CENTER = 'icon-client-center',
	X_MARK_BLUE = 'icon-x-mark-blue',
	X_MARK_CYCLAMEN = 'icon-x-mark-cyclamen',
	LABORATORY = 'icon-laboratory',
	MAN = 'icon-man',
	WOMAN = 'icon-woman',
	OK = 'icon-ok',
	PERSONAL_DEVELOPMENT = 'icon-personal-development',
	PREVENTION = 'icon-prevention',
	SERVICE_1 = 'icon-service-1',
	SERVICE_2 = 'icon-service-2',
	SERVICE_3 = 'icon-service-3',
	SERVICE_4 = 'icon-service-4',
	TOOTH = 'icon-tooth'
}

export interface IPreventiveExaminationReduced extends IBase {
	aladarId: string
	aladarName: string
	aladarDescription: string
	aladarText: string
	name: string
	description: string
	price: number
	priceOld: number | null
	priceInsurance: number
	text: OutputData
	modules: IProgramModule[]
	benefits: IBenefit[]
	isFeatured: boolean | undefined
	isExpanded: boolean | undefined
	url?: string
}

export interface IPreventiveExamination extends IPreventiveExaminationReduced {}
